import styled from 'styled-components';
import Icon from '../../Icon/Icon';

export const StyledFacebookIcon = styled(Icon)`
  justify-content: center;
  color: #1877f2;
  fill: #1877f2; // FB logo color
`;
